import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=2b8b1c04&scoped=true"
import script from "./Spinner.js?vue&type=script&lang=js&external"
export * from "./Spinner.js?vue&type=script&lang=js&external"
import style0 from "./Spinner.scss?vue&type=style&index=0&id=2b8b1c04&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b1c04",
  null
  
)

export default component.exports